module.exports = __webpack_public_path__ + "img/17.d865e247.jpg";